export default __webpack_public_path__ + "static/media/pdcconsultOrganogram.0eabe577.png";